module.exports = __webpack_public_path__ + "img/foto-3.14ca3910.png";